/**
 * @deprecated Please use the new NextContentTagVariant
 */
let ContentTagVariant = /*#__PURE__*/function (ContentTagVariant) {
  ContentTagVariant["REGULAR"] = "regular";
  ContentTagVariant["LARGE"] = "large";
  return ContentTagVariant;
}({});

export { ContentTagVariant };
//# sourceMappingURL=variant.js.map
